export const contentLibrarySchema = {
  type: 'content-library',
  label: 'Content Library',
  description: 'Showcase your study materials, PGNs, and puzzles',
  icon: 'BookMarked',
  defaultContent: {
    title: 'Content Library',
    description: 'Study materials, PGN files, and interactive puzzles',
    maxItems: 6,
    buttonText: 'Browse Library',
    style: {},
  },
  fields: [],
};
